export default {
  introSteps: {
    exportFile: 'Exporte la encuesta sin datos desde el otro servidor de Arena (p. ej. Dev o QA)',
    selectFile: 'Seleccione el archivo exportado (.zip): se compara con esta encuesta y se muestran las diferencias',
    applyChanges:
      'Revise las diferencias y aplique los cambios seleccionados a esta encuesta (las eliminaciones nunca se seleccionan por defecto)',
    publish:
      'Los cambios se guardan como borrador: pruebe el formulario y publique la encuesta para que sean efectivos',
  },
  fileTooLarge:
    'El archivo seleccionado es demasiado grande (máx. {{maxSize}} MB): exporte la encuesta sin datos, los registros y sus archivos no son necesarios para comparar encuestas',
  selectNewSource: 'Seleccionar un nuevo origen',
  selectNewSourceInfo: 'Descartar esta comparación y seleccionar otro archivo de encuesta u otra encuesta',
  refreshComparison: 'Actualizar comparación',
  refreshComparisonInfo:
    'Comparar de nuevo el mismo archivo con la versión actual de esta encuesta (p. ej. después de editarla)',
  sourceSurvey: 'Encuesta comparada: {{name}}',
  compareWithSurvey: 'O compare con otra encuesta de este servidor:',
  fingerprint: {
    thisSurvey: 'Esta encuesta',
    comparedSurvey: 'Encuesta comparada',
    equal: 'Igual que esta encuesta',
    different: 'Diferente de esta encuesta',
    label: 'Huella',
    structural: 'estructural',
    info: 'Huellas de la definición de la encuesta (borrador). Huellas iguales significan definiciones iguales. La primera incluye los identificadores internos: es igual solo para copias de la misma encuesta (p. ej. exportada e importada en otro servidor). La estructural usa nombres y códigos: es igual también para encuestas creadas por separado con la misma estructura. Nombres, etiquetas, identificadores, fechas y estado de publicación no forman parte de ella.',
    copy: 'Copiar la huella completa: {{value}}',
    copied: 'Huella copiada al portapapeles',
  },
  identical: 'Las encuestas son idénticas',
  counts: '{{added}} solo en la encuesta comparada, {{changed}} modificados, {{removed}} solo en esta encuesta',
  surveyInfoChanged:
    'La información de la encuesta (idiomas, ciclos, etiquetas) es diferente: vea la pestaña "Información de la encuesta"',
  onlyDifferences: 'Mostrar solo las diferencias',
  hideLayoutOnly: 'Ocultar las diferencias solo de diseño',
  apply: 'Aplicar los cambios seleccionados ({{count}})',
  applyConfirm: `¿Aplicar {{count}} cambios seleccionados a esta encuesta?
Los cambios se guardan como borrador: llegarán a los registros solo cuando se publique la encuesta.`,
  willBeDeleted: 'se eliminará',
  removedNodeDefInfo:
    'Esta definición de nodo solo está en esta encuesta: aplicar este cambio la elimina (junto con sus descendientes) de esta encuesta.',
  removedItemInfo: 'Solo en esta encuesta: aplicar este cambio lo elimina de esta encuesta.',
  applyConfirmWithDeletionsHeader: 'Confirmar las eliminaciones',
  applyConfirmWithDeletions:
    '¿Aplicar {{count}} cambios seleccionados a esta encuesta?\n\n**{{deletionsCount}} de ellos eliminan elementos de esta encuesta** (elementos que no están en la encuesta comparada):\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: 'Aplicar y eliminar',
  confirmSurveyName: 'Introduzca el nombre de esta encuesta para confirmar:',
  deletionOfItemsOf: 'elementos solo en esta encuesta de **{{name}}**',
  moreDeletions: '... y {{count}} más',
  applyCompleted:
    'Cambios aplicados: {{applied}}, omitidos: {{skipped}}. Publique la encuesta para que sean efectivos.',
  tabs: {
    nodeDefs: 'Definiciones de nodos',
    categories: 'Categorías',
    taxonomies: 'Taxonomías',
    surveyInfo: 'Información de la encuesta',
    surveyFiles: 'Archivos',
  },
  status: {
    added: 'Solo en la encuesta comparada',
    changed: 'Modificado',
    removed: 'Solo en esta encuesta',
  },
  statusLabel: 'Estado',
  matchedBy: {
    uuid: 'Emparejado por identificador interno',
    name: 'Emparejado por nombre (los identificadores internos son diferentes)',
    manual: 'Emparejado manualmente: se aplica como cambio de nombre',
  },
  renameCandidate: 'Podría ser "{{name}}" de esta encuesta, con otro nombre',
  possibleRename: 'posible cambio de nombre',
  matchAsRename: 'Emparejar como renombrado',
  unmatch: 'Deshacer emparejamiento',
  props: {
    branding: 'Imagen de marca',
    columnsNo: 'Columnas',
    columnsOrder: 'Orden de las columnas',
    cycles: 'Ciclos',
    defaultCycleKey: 'Ciclo predeterminado',
    descriptions: 'Descripciones',
    extra: 'Propiedades adicionales',
    family: 'Familia',
    fieldManualLinks: 'Enlaces al manual de campo',
    formLayout: 'Diseño del formulario',
    genus: 'Género',
    gridPosition: 'fila {{row}}, columna {{column}}, ancho {{width}}, alto {{height}}',
    itemExtraDef: 'Propiedades adicionales',
    keepNonApplicableValues: 'Conservar los valores no relevantes',
    labels: 'Etiquetas',
    languages: 'Idiomas',
    layout: 'Diseño',
    levels: 'Niveles',
    messages: 'Mensajes',
    pagesOrder: 'Orden de las páginas',
    parent: 'Entidad padre',
    preloadedMapLayersEnabled: 'Capas de mapa precargadas habilitadas',
    reportingData: 'Datos de informes',
    sampleBasedImageInterpretationEnabled: 'Interpretación de imágenes basada en muestras',
    samplingPolygon: 'Polígono de muestreo',
    scientificName: 'Nombre científico',
    size: 'Tamaño',
    srs: 'Sistemas de referencia espacial',
    surveyDocOptions: 'Opciones de la documentación de la encuesta',
    userExtraPropDefs: 'Propiedades adicionales de usuario',
    validations: 'Validaciones',
    vernacularLanguageCodes: 'Idiomas de los nombres vernáculos',
    vernacularNames: 'Nombres vernáculos',
  },
  fileTypes: {
    preloadedMapLayer: 'Capa de mapa precargada',
    surveyDocImage: 'Imagen de la documentación de la encuesta',
    brandingSurveyLogo1: 'Logotipo de la encuesta 1',
    brandingSurveyLogo2: 'Logotipo de la encuesta 2',
    brandingSurveyLogo3: 'Logotipo de la encuesta 3',
    brandingLandingBackground: 'Fondo de la página de inicio',
  },
  cycle: 'ciclo {{cycle}}',
  property: 'Propiedad',
  sourceValue: 'Encuesta comparada',
  targetValue: 'Esta encuesta',
  emptyValue: '(vacío)',
  layoutOnly: 'solo diseño',
  selectItem: 'Seleccione un elemento para ver los detalles',
  noDifferences: 'Sin diferencias',
  identicalItem: 'Sin diferencias',
  dependsOn: 'Se aplica junto con:',
  itemsCount: 'elementos: {{added}} añadidos, {{changed}} modificados, {{removed}} solo en esta encuesta',
  itemCode: 'Código',
  taxaCount: 'taxones: {{added}} añadidos, {{changed}} modificados, {{removed}} solo en esta encuesta',
  taxonCode: 'Código',
  changes: 'Cambios',
  moreItems: '... y {{count}} elementos más',
  categoryRemoval: 'Eliminar los elementos (y niveles) que solo están en esta encuesta',
  taxonomyRemoval: 'Eliminar los taxones y nombres vernáculos que solo están en esta encuesta',
  removalSelected: 'eliminación seleccionada',
  publishedKept: '(publicados: se mantienen)',
  reasons: {
    categoryInUse: 'La categoría la usan definiciones de nodos que no se eliminan',
    categoryMissing: 'La categoría no existe en esta encuesta',
    cycleMissing: 'Falta un ciclo en esta encuesta',
    dependencyNotApplicable: 'Un cambio del que depende no se puede aplicar',
    parentMissing: 'La definición de nodo padre no existe en esta encuesta',
    publishedCategoryChanged: 'No se puede cambiar la categoría de una definición de nodo publicada',
    publishedKeyChanged: 'No se puede cambiar la propiedad "clave" de una definición de nodo publicada',
    publishedMoveNotSupported: 'Una definición de nodo publicada no se puede mover a otra entidad',
    publishedMultipleChanged: 'No se puede cambiar la propiedad "múltiple" de una definición de nodo publicada',
    publishedTaxonomyChanged: 'No se puede cambiar la taxonomía de una definición de nodo publicada',
    publishedTypeChanged: 'No se puede cambiar el tipo de una definición de nodo publicada',
    taxonomyInUse: 'La taxonomía la usan definiciones de nodos que no se eliminan',
    taxonomyMissing: 'La taxonomía no existe en esta encuesta',
    nodeDefUsedByOthers: 'Otras definiciones de nodos la usan en sus expresiones: actualícelas también',
    publishedCategoryItemsKept: 'Los elementos publicados no se pueden eliminar: se mantienen',
    publishedCategoryLevelsKept: 'Los niveles publicados no se pueden eliminar: se mantienen',
    publishedCyclesRemoved: 'Eliminar ciclos de una definición de nodo publicada elimina sus datos en esos ciclos',
    publishedLanguagesRemoved: 'Eliminar idiomas borra sus etiquetas cuando se publica la encuesta',
    publishedNameChanged:
      'Cambio de nombre de una definición de nodo publicada: hay que actualizar las expresiones que usan el nombre anterior',
    publishedNodeDefDeleted:
      'La definición de nodo está publicada: sus datos se eliminarán cuando se publique la encuesta',
    publishedSurveyCyclesRemoved: 'Eliminar ciclos borra sus registros cuando se publica la encuesta',
    publishedTaxaKept: 'Los taxones publicados no se pueden eliminar: se mantienen',
    publishedVernacularNamesKept: 'Los nombres vernáculos publicados no se pueden eliminar: se mantienen',
  },
}
